module.exports = __webpack_public_path__ + "img/cwg_kongzhiqi.130df691.png";